import { useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import SignatureCanvas from "react-signature-canvas";
import { X, RotateCcw, Check } from "lucide-react";
import { Button } from "../ui/button";

export const FullScreenCapture = ({ title, subtitle, onSave, onCancel, existingImage }) => {
  const sigRef = useRef(null);
  const containerRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const resizeCanvas = () => {
      if (containerRef.current && sigRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const canvas = sigRef.current.getCanvas();
        canvas.width = rect.width;
        canvas.height = rect.height;
        sigRef.current.clear();
        setIsEmpty(true);
      }
    };
    const timer = setTimeout(resizeCanvas, 150);
    window.addEventListener("resize", resizeCanvas);
    return () => { clearTimeout(timer); window.removeEventListener("resize", resizeCanvas); };
  }, []);

  const handleClear = () => {
    sigRef.current?.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (sigRef.current?.isEmpty()) {
      toast.error("Por favor, escriba antes de validar");
      return;
    }
    const dataUrl = sigRef.current.toDataURL("image/png");
    onSave(dataUrl);
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col" data-testid="fullscreen-capture">
      <div className="flex items-center justify-between px-4 py-3 bg-slate-800 text-white shrink-0">
        <button onClick={onCancel} className="p-2 -m-2" data-testid="capture-cancel">
          <X size={24} />
        </button>
        <div className="text-center">
          <div className="font-semibold text-sm">{title}</div>
          {subtitle && <div className="text-xs text-slate-300">{subtitle}</div>}
        </div>
        <button onClick={handleClear} className="p-2 -m-2" data-testid="capture-clear">
          <RotateCcw size={20} />
        </button>
      </div>
      <div ref={containerRef} className="flex-1 relative border-2 border-dashed border-slate-200 m-2 rounded-lg overflow-hidden">
        <SignatureCanvas
          ref={sigRef}
          canvasProps={{
            className: "absolute inset-0",
            style: { width: "100%", height: "100%", touchAction: "none" }
          }}
          backgroundColor="white"
          penColor="black"
          minWidth={1.5}
          maxWidth={3}
          onBegin={() => setIsEmpty(false)}
        />
        {isEmpty && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <p className="text-slate-300 text-lg">{subtitle || "Escriba aquí"}</p>
          </div>
        )}
      </div>
      <div className="p-4 shrink-0">
        <Button
          onClick={handleSave}
          className="w-full h-14 text-lg font-semibold bg-emerald-600 hover:bg-emerald-700"
          data-testid="capture-save"
        >
          <Check size={24} className="mr-2" /> Validar
        </Button>
      </div>
    </div>
  );
};
